// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               v5.28.3
// source: eventstores.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import type { CallContext, CallOptions } from "nice-grpc-common";
import { Empty } from "./google/protobuf/empty";
import { Guid } from "./protobuf-net/bcl";

export const protobufPackage = "Cratis.Chronicle.Contracts.EventStores";

export enum ValidationResultSeverity {
  Unknown = 0,
  Information = 1,
  Warning = 2,
  Error = 3,
  UNRECOGNIZED = -1,
}

export function validationResultSeverityFromJSON(object: any): ValidationResultSeverity {
  switch (object) {
    case 0:
    case "Unknown":
      return ValidationResultSeverity.Unknown;
    case 1:
    case "Information":
      return ValidationResultSeverity.Information;
    case 2:
    case "Warning":
      return ValidationResultSeverity.Warning;
    case 3:
    case "Error":
      return ValidationResultSeverity.Error;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ValidationResultSeverity.UNRECOGNIZED;
  }
}

export function validationResultSeverityToJSON(object: ValidationResultSeverity): string {
  switch (object) {
    case ValidationResultSeverity.Unknown:
      return "Unknown";
    case ValidationResultSeverity.Information:
      return "Information";
    case ValidationResultSeverity.Warning:
      return "Warning";
    case ValidationResultSeverity.Error:
      return "Error";
    case ValidationResultSeverity.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface CommandResult {
  /** default value could not be applied: 00000000-0000-0000-0000-000000000000 */
  CorrelationId: Guid | undefined;
  IsAuthorized: boolean;
  ValidationResults: ValidationResult[];
  ExceptionMessages: string[];
  ExceptionStackTrace: string;
  AuthorizationFailureReason: string;
}

export interface EnsureEventStoreRequest {
  Name: string;
}

export interface EventStoreNamesResponse {
  Name: string;
  Id: string;
}

export interface QueryResultIEnumerableEventStoreNamesResponse {
  /** default value could not be applied: 00000000-0000-0000-0000-000000000000 */
  CorrelationId: Guid | undefined;
  IsAuthorized: boolean;
  ValidationResults: ValidationResult[];
  ExceptionMessages: string[];
  ExceptionStackTrace: string;
  Data: EventStoreNamesResponse[];
}

export interface ValidationResult {
  /** default value could not be applied: Error */
  Severity: ValidationResultSeverity;
  Message: string;
  Members: string[];
}

function createBaseCommandResult(): CommandResult {
  return {
    CorrelationId: undefined,
    IsAuthorized: false,
    ValidationResults: [],
    ExceptionMessages: [],
    ExceptionStackTrace: "",
    AuthorizationFailureReason: "",
  };
}

export const CommandResult: MessageFns<CommandResult> = {
  encode(message: CommandResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.CorrelationId !== undefined) {
      Guid.encode(message.CorrelationId, writer.uint32(10).fork()).join();
    }
    if (message.IsAuthorized !== false) {
      writer.uint32(16).bool(message.IsAuthorized);
    }
    for (const v of message.ValidationResults) {
      ValidationResult.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.ExceptionMessages) {
      writer.uint32(34).string(v!);
    }
    if (message.ExceptionStackTrace !== "") {
      writer.uint32(42).string(message.ExceptionStackTrace);
    }
    if (message.AuthorizationFailureReason !== "") {
      writer.uint32(50).string(message.AuthorizationFailureReason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommandResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCommandResult();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.CorrelationId = Guid.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.IsAuthorized = reader.bool();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.ValidationResults.push(ValidationResult.decode(reader, reader.uint32()));
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.ExceptionMessages.push(reader.string());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.ExceptionStackTrace = reader.string();
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.AuthorizationFailureReason = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): CommandResult {
    return {
      CorrelationId: isSet(object.CorrelationId) ? Guid.fromJSON(object.CorrelationId) : undefined,
      IsAuthorized: isSet(object.IsAuthorized) ? globalThis.Boolean(object.IsAuthorized) : false,
      ValidationResults: globalThis.Array.isArray(object?.ValidationResults)
        ? object.ValidationResults.map((e: any) => ValidationResult.fromJSON(e))
        : [],
      ExceptionMessages: globalThis.Array.isArray(object?.ExceptionMessages)
        ? object.ExceptionMessages.map((e: any) => globalThis.String(e))
        : [],
      ExceptionStackTrace: isSet(object.ExceptionStackTrace) ? globalThis.String(object.ExceptionStackTrace) : "",
      AuthorizationFailureReason: isSet(object.AuthorizationFailureReason)
        ? globalThis.String(object.AuthorizationFailureReason)
        : "",
    };
  },

  toJSON(message: CommandResult): unknown {
    const obj: any = {};
    if (message.CorrelationId !== undefined) {
      obj.CorrelationId = Guid.toJSON(message.CorrelationId);
    }
    if (message.IsAuthorized !== false) {
      obj.IsAuthorized = message.IsAuthorized;
    }
    if (message.ValidationResults?.length) {
      obj.ValidationResults = message.ValidationResults.map((e) => ValidationResult.toJSON(e));
    }
    if (message.ExceptionMessages?.length) {
      obj.ExceptionMessages = message.ExceptionMessages;
    }
    if (message.ExceptionStackTrace !== "") {
      obj.ExceptionStackTrace = message.ExceptionStackTrace;
    }
    if (message.AuthorizationFailureReason !== "") {
      obj.AuthorizationFailureReason = message.AuthorizationFailureReason;
    }
    return obj;
  },

  create(base?: DeepPartial<CommandResult>): CommandResult {
    return CommandResult.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CommandResult>): CommandResult {
    const message = createBaseCommandResult();
    message.CorrelationId = (object.CorrelationId !== undefined && object.CorrelationId !== null)
      ? Guid.fromPartial(object.CorrelationId)
      : undefined;
    message.IsAuthorized = object.IsAuthorized ?? false;
    message.ValidationResults = object.ValidationResults?.map((e) => ValidationResult.fromPartial(e)) || [];
    message.ExceptionMessages = object.ExceptionMessages?.map((e) => e) || [];
    message.ExceptionStackTrace = object.ExceptionStackTrace ?? "";
    message.AuthorizationFailureReason = object.AuthorizationFailureReason ?? "";
    return message;
  },
};

function createBaseEnsureEventStoreRequest(): EnsureEventStoreRequest {
  return { Name: "" };
}

export const EnsureEventStoreRequest: MessageFns<EnsureEventStoreRequest> = {
  encode(message: EnsureEventStoreRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Name !== "") {
      writer.uint32(10).string(message.Name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnsureEventStoreRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseEnsureEventStoreRequest();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.Name = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): EnsureEventStoreRequest {
    return { Name: isSet(object.Name) ? globalThis.String(object.Name) : "" };
  },

  toJSON(message: EnsureEventStoreRequest): unknown {
    const obj: any = {};
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    return obj;
  },

  create(base?: DeepPartial<EnsureEventStoreRequest>): EnsureEventStoreRequest {
    return EnsureEventStoreRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EnsureEventStoreRequest>): EnsureEventStoreRequest {
    const message = createBaseEnsureEventStoreRequest();
    message.Name = object.Name ?? "";
    return message;
  },
};

function createBaseEventStoreNamesResponse(): EventStoreNamesResponse {
  return { Name: "", Id: "" };
}

export const EventStoreNamesResponse: MessageFns<EventStoreNamesResponse> = {
  encode(message: EventStoreNamesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Name !== "") {
      writer.uint32(10).string(message.Name);
    }
    if (message.Id !== "") {
      writer.uint32(18).string(message.Id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EventStoreNamesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseEventStoreNamesResponse();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.Name = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.Id = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): EventStoreNamesResponse {
    return {
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
    };
  },

  toJSON(message: EventStoreNamesResponse): unknown {
    const obj: any = {};
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    return obj;
  },

  create(base?: DeepPartial<EventStoreNamesResponse>): EventStoreNamesResponse {
    return EventStoreNamesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EventStoreNamesResponse>): EventStoreNamesResponse {
    const message = createBaseEventStoreNamesResponse();
    message.Name = object.Name ?? "";
    message.Id = object.Id ?? "";
    return message;
  },
};

function createBaseQueryResultIEnumerableEventStoreNamesResponse(): QueryResultIEnumerableEventStoreNamesResponse {
  return {
    CorrelationId: undefined,
    IsAuthorized: false,
    ValidationResults: [],
    ExceptionMessages: [],
    ExceptionStackTrace: "",
    Data: [],
  };
}

export const QueryResultIEnumerableEventStoreNamesResponse: MessageFns<QueryResultIEnumerableEventStoreNamesResponse> =
  {
    encode(
      message: QueryResultIEnumerableEventStoreNamesResponse,
      writer: BinaryWriter = new BinaryWriter(),
    ): BinaryWriter {
      if (message.CorrelationId !== undefined) {
        Guid.encode(message.CorrelationId, writer.uint32(10).fork()).join();
      }
      if (message.IsAuthorized !== false) {
        writer.uint32(16).bool(message.IsAuthorized);
      }
      for (const v of message.ValidationResults) {
        ValidationResult.encode(v!, writer.uint32(26).fork()).join();
      }
      for (const v of message.ExceptionMessages) {
        writer.uint32(34).string(v!);
      }
      if (message.ExceptionStackTrace !== "") {
        writer.uint32(42).string(message.ExceptionStackTrace);
      }
      for (const v of message.Data) {
        EventStoreNamesResponse.encode(v!, writer.uint32(50).fork()).join();
      }
      return writer;
    },

    decode(input: BinaryReader | Uint8Array, length?: number): QueryResultIEnumerableEventStoreNamesResponse {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
      const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
      if (previousRecursionDepth >= 100) {
        throw new globalThis.Error("protobuf decode recursion limit exceeded");
      }
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
      try {
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryResultIEnumerableEventStoreNamesResponse();
        while (reader.pos < end) {
          const tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              if (tag !== 10) {
                break;
              }

              message.CorrelationId = Guid.decode(reader, reader.uint32());
              continue;
            }
            case 2: {
              if (tag !== 16) {
                break;
              }

              message.IsAuthorized = reader.bool();
              continue;
            }
            case 3: {
              if (tag !== 26) {
                break;
              }

              message.ValidationResults.push(ValidationResult.decode(reader, reader.uint32()));
              continue;
            }
            case 4: {
              if (tag !== 34) {
                break;
              }

              message.ExceptionMessages.push(reader.string());
              continue;
            }
            case 5: {
              if (tag !== 42) {
                break;
              }

              message.ExceptionStackTrace = reader.string();
              continue;
            }
            case 6: {
              if (tag !== 50) {
                break;
              }

              message.Data.push(EventStoreNamesResponse.decode(reader, reader.uint32()));
              continue;
            }
          }
          if ((tag & 7) === 4 || tag === 0) {
            break;
          }
          reader.skip(tag & 7);
        }
        return message;
      } finally {
        (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
      }
    },

    fromJSON(object: any): QueryResultIEnumerableEventStoreNamesResponse {
      return {
        CorrelationId: isSet(object.CorrelationId) ? Guid.fromJSON(object.CorrelationId) : undefined,
        IsAuthorized: isSet(object.IsAuthorized) ? globalThis.Boolean(object.IsAuthorized) : false,
        ValidationResults: globalThis.Array.isArray(object?.ValidationResults)
          ? object.ValidationResults.map((e: any) => ValidationResult.fromJSON(e))
          : [],
        ExceptionMessages: globalThis.Array.isArray(object?.ExceptionMessages)
          ? object.ExceptionMessages.map((e: any) => globalThis.String(e))
          : [],
        ExceptionStackTrace: isSet(object.ExceptionStackTrace) ? globalThis.String(object.ExceptionStackTrace) : "",
        Data: globalThis.Array.isArray(object?.Data)
          ? object.Data.map((e: any) => EventStoreNamesResponse.fromJSON(e))
          : [],
      };
    },

    toJSON(message: QueryResultIEnumerableEventStoreNamesResponse): unknown {
      const obj: any = {};
      if (message.CorrelationId !== undefined) {
        obj.CorrelationId = Guid.toJSON(message.CorrelationId);
      }
      if (message.IsAuthorized !== false) {
        obj.IsAuthorized = message.IsAuthorized;
      }
      if (message.ValidationResults?.length) {
        obj.ValidationResults = message.ValidationResults.map((e) => ValidationResult.toJSON(e));
      }
      if (message.ExceptionMessages?.length) {
        obj.ExceptionMessages = message.ExceptionMessages;
      }
      if (message.ExceptionStackTrace !== "") {
        obj.ExceptionStackTrace = message.ExceptionStackTrace;
      }
      if (message.Data?.length) {
        obj.Data = message.Data.map((e) => EventStoreNamesResponse.toJSON(e));
      }
      return obj;
    },

    create(
      base?: DeepPartial<QueryResultIEnumerableEventStoreNamesResponse>,
    ): QueryResultIEnumerableEventStoreNamesResponse {
      return QueryResultIEnumerableEventStoreNamesResponse.fromPartial(base ?? {});
    },
    fromPartial(
      object: DeepPartial<QueryResultIEnumerableEventStoreNamesResponse>,
    ): QueryResultIEnumerableEventStoreNamesResponse {
      const message = createBaseQueryResultIEnumerableEventStoreNamesResponse();
      message.CorrelationId = (object.CorrelationId !== undefined && object.CorrelationId !== null)
        ? Guid.fromPartial(object.CorrelationId)
        : undefined;
      message.IsAuthorized = object.IsAuthorized ?? false;
      message.ValidationResults = object.ValidationResults?.map((e) => ValidationResult.fromPartial(e)) || [];
      message.ExceptionMessages = object.ExceptionMessages?.map((e) => e) || [];
      message.ExceptionStackTrace = object.ExceptionStackTrace ?? "";
      message.Data = object.Data?.map((e) => EventStoreNamesResponse.fromPartial(e)) || [];
      return message;
    },
  };

function createBaseValidationResult(): ValidationResult {
  return { Severity: 0, Message: "", Members: [] };
}

export const ValidationResult: MessageFns<ValidationResult> = {
  encode(message: ValidationResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Severity !== 0) {
      writer.uint32(8).int32(message.Severity);
    }
    if (message.Message !== "") {
      writer.uint32(18).string(message.Message);
    }
    for (const v of message.Members) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ValidationResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseValidationResult();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.Severity = reader.int32() as any;
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.Message = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.Members.push(reader.string());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ValidationResult {
    return {
      Severity: isSet(object.Severity) ? validationResultSeverityFromJSON(object.Severity) : 0,
      Message: isSet(object.Message) ? globalThis.String(object.Message) : "",
      Members: globalThis.Array.isArray(object?.Members) ? object.Members.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: ValidationResult): unknown {
    const obj: any = {};
    if (message.Severity !== 0) {
      obj.Severity = validationResultSeverityToJSON(message.Severity);
    }
    if (message.Message !== "") {
      obj.Message = message.Message;
    }
    if (message.Members?.length) {
      obj.Members = message.Members;
    }
    return obj;
  },

  create(base?: DeepPartial<ValidationResult>): ValidationResult {
    return ValidationResult.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ValidationResult>): ValidationResult {
    const message = createBaseValidationResult();
    message.Severity = object.Severity ?? 0;
    message.Message = object.Message ?? "";
    message.Members = object.Members?.map((e) => e) || [];
    return message;
  },
};

export type EventStoresDefinition = typeof EventStoresDefinition;
export const EventStoresDefinition = {
  name: "EventStores",
  fullName: "Cratis.Chronicle.Contracts.EventStores.EventStores",
  methods: {
    allEventStores: {
      name: "AllEventStores",
      requestType: Empty as typeof Empty,
      requestStream: false,
      responseType:
        QueryResultIEnumerableEventStoreNamesResponse as typeof QueryResultIEnumerableEventStoreNamesResponse,
      responseStream: false,
      options: {},
    },
    ensureEventStore: {
      name: "EnsureEventStore",
      requestType: EnsureEventStoreRequest as typeof EnsureEventStoreRequest,
      requestStream: false,
      responseType: CommandResult as typeof CommandResult,
      responseStream: false,
      options: {},
    },
    observeEventStores: {
      name: "ObserveEventStores",
      requestType: Empty as typeof Empty,
      requestStream: false,
      responseType:
        QueryResultIEnumerableEventStoreNamesResponse as typeof QueryResultIEnumerableEventStoreNamesResponse,
      responseStream: true,
      options: {},
    },
  },
} as const;

export interface EventStoresServiceImplementation<CallContextExt = {}> {
  allEventStores(
    request: Empty,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<QueryResultIEnumerableEventStoreNamesResponse>>;
  ensureEventStore(
    request: EnsureEventStoreRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CommandResult>>;
  observeEventStores(
    request: Empty,
    context: CallContext & CallContextExt,
  ): ServerStreamingMethodResult<DeepPartial<QueryResultIEnumerableEventStoreNamesResponse>>;
}

export interface EventStoresClient<CallOptionsExt = {}> {
  allEventStores(
    request: DeepPartial<Empty>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<QueryResultIEnumerableEventStoreNamesResponse>;
  ensureEventStore(
    request: DeepPartial<EnsureEventStoreRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CommandResult>;
  observeEventStores(
    request: DeepPartial<Empty>,
    options?: CallOptions & CallOptionsExt,
  ): AsyncIterable<QueryResultIEnumerableEventStoreNamesResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | bigint | undefined;

export type DeepPartial<T> = T extends bigint ? string | number | bigint
  : T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export type ServerStreamingMethodResult<Response> = { [Symbol.asyncIterator](): AsyncIterator<Response, void> };

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
